module.exports = __webpack_public_path__ + "img/c-en-16.340f4fcf.png";